import React, { Component } from 'react'
import { Table } from 'hljd'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import columns from '../../column'
import store from '../../store'

@observer
export default class extends Component {
  componentDidMount() {
    let _s = store.form.status
    if (_s == 'all') {
      _s = ''
    }
    store.OrderAction('tab=' + store.tabkey + '&per_page=10&status=' + _s)
  }

  render() {
    let { list, loading, pagination_all } = store
    return (
      <div>
        <Table
          rowKey={record => record.id}
          loading={loading}
          bordered
          columns={columns}
          dataSource={toJS(list)}
          pagination={pagination_all}
          onChange={store.paging('all')}
        />
      </div>
    )
  }
}
